export default "__VITE_ASSET__BnN96Q3m__"